import { EventDifficultyLevel } from '../../../../../../App.types'

export const LEVEL_TRANSLATION_MAPPING: Record<
  EventDifficultyLevel,
  'level-all' | 'level-beginner' | 'level-intermediate' | 'level-advanced'
> = {
  [EventDifficultyLevel.ALL]: 'level-all',
  [EventDifficultyLevel.BEGINNER]: 'level-beginner',
  [EventDifficultyLevel.INTERMEDIATE]: 'level-intermediate',
  [EventDifficultyLevel.PROFESSIONAL]: 'level-advanced',
}
